import { jsx as _jsx } from "react/jsx-runtime";
import { BaseTransactionButton } from '../../components/BaseTransactionButton/BaseTransactionButton.js';
import { useMessageQueue } from '../../components/Messages/useMessageQueue.js';
export const StartTransactionButton = ({ onClick, route, text, loading, }) => {
    const { hasMessages, isLoading } = useMessageQueue(route, true);
    return (_jsx(BaseTransactionButton, { onClick: onClick, text: text, disabled: hasMessages, loading: isLoading || loading }));
};
//# sourceMappingURL=StartTransactionButton.js.map